import { render, staticRenderFns } from "./importFile.vue?vue&type=template&id=cc386a96&"
import script from "./importFile.vue?vue&type=script&lang=js&"
export * from "./importFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports